import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Functions
import { levelsByProtocol } from "../../../functions";
// Components
import { MainDiv, PositionerLevelsDiv, LevelsDiv, LevelButton } from "./styles";
import Graphic from "../../../../graphic";

const PlotWithLevels = ({ title, data, axisY, axisX, max, showLegend, currentLevel, setCurrentLevel }) => {
  const [levels] = useState(new Array(levelsByProtocol).fill(0).map((_, i) => i));
  const [t] = useTranslation("global");

  const renderLevels = () => {
    return levels.map((level) => {
      return (
        <LevelButton key={level} onClick={() => setCurrentLevel(level)} borderLeft active={currentLevel === level}>
          {`${t("level")} ${level + 1}`}
        </LevelButton>
      );
    });
  };

  return (
    <MainDiv>
      <PositionerLevelsDiv>
        <LevelsDiv>
          <LevelButton onClick={() => setCurrentLevel("total")} active={currentLevel === "total"}>
            {t("total")}
          </LevelButton>
          {renderLevels()}
        </LevelsDiv>
      </PositionerLevelsDiv>
      <Graphic
        Title={title}
        Type={Line}
        data={data}
        axisY={axisY}
        axisX={axisX}
        max={max ? max : 0}
        margin="0"
        showLegend={showLegend}
        shadow={""}
      />
    </MainDiv>
  );
};

export default PlotWithLevels;
